import { useMemo, useRef } from "react";
import { Modal, Table, Tabs } from "antd";

import AssignIssue from "./components/AssignIssue";
import IssueGenerator from "./components/IssueGenerator";

const GenerateSubIssuesModal = ({
  sub_issues,
  current_issue_id,
  issue_group_id,
  handleClose,
  refetch,
}) => {
  const ref = useRef();

  const table_columns = [
    {
      title: "Lp.",
      dataIndex: "lp",
      width: 40,
    },
    {
      title: "Ulica",
      dataIndex: "client_street",
      editable: true,
    },
    {
      title: "Nr budynku",
      dataIndex: "client_building_number",
      width: 100,
    },
    {
      title: "Nr mieszkania",
      dataIndex: "client_apartment_number",
      width: 120,
    },
  ];

  const data = useMemo(
    () =>
      sub_issues.map((sub_issue, index) => ({
        lp: index + 1,
        key: sub_issue?.id,
        client_street: sub_issue?.client_street,
        client_building_number: sub_issue?.client_building_number,
        client_apartment_number: sub_issue?.client_apartment_number,
      })),
    [sub_issues]
  );

  return (
    <Modal
      style={{ top: 45 }}
      maskClosable={false}
      width={700}
      title="Dodaj podzgłoszenia"
      open={true}
      onCancel={handleClose}
      cancelText="Anuluj"
      okText="Utwórz"
      key={ref}
      footer={null}
    >
      <Tabs
        items={[
          {
            key: "1",
            label: "Nowe zgłoszenia",
            children: (
              <>
                {data?.length > 0 && (
                  <Table
                    size="small"
                    columns={table_columns}
                    scroll={{ x: "max-content", y: 140 }}
                    dataSource={data}
                    pagination={false}
                  />
                )}
                <IssueGenerator
                  issue_group_id={issue_group_id}
                  refetch={refetch}
                  handleClose={handleClose}
                />
              </>
            ),
          },
          {
            key: "2",
            label: "Istniejące zgłoszenia",
            children: (
              <AssignIssue
                issue_group_id={issue_group_id}
                current_issue_id={current_issue_id}
                refetch={refetch}
                handleClose={handleClose}
              />
            ),
          },
        ]}
      />
    </Modal>
  );
};

export default GenerateSubIssuesModal;
